import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { useCallback } from 'react'
import { AlternateLanguage } from '@prismicio/types'
import { SizeVariant } from 'enums'

import { Button } from 'components/buttons'

import { getLocaleCodeFromPrismicLang } from 'utils/prismic'

import { IAlternativeArticleLangProps } from './types'

const getLocaleFromAlternative = (alternative: AlternateLanguage) =>
  getLocaleCodeFromPrismicLang(alternative.lang) ?? 'en'

const AlternativeArticleLang = ({ pageData }: IAlternativeArticleLangProps) => {
  const router = useRouter()
  const { t } = useTranslation(['community'])

  const handleRedirect = useCallback(
    (lang: string, uid: string) => () => {
      window.location.replace(
        `/${lang}/${
          lang === 'lt' ? 'ekspertu-izvalgos' : 'expert-insights'
        }/${uid}`
      )
    },
    []
  )

  const getTitle = useCallback(
    (locale: string) => {
      const title = pageData.data.alternativeLanguages.find(
        (item) => item.language === locale
      )

      if (title) {
        return title.title
      }

      return t('version', { ns: 'community' })
    },
    [pageData.data.alternativeLanguages, t]
  )

  return (
    <div className="flex flex-col items-center justify-center">
      <h4 className="max-w-[620px] text-center text-2xl font-medium">
        {t('alternativeLang', { ns: 'community' })}
      </h4>

      <div className="mt-4">
        {pageData.alternate_languages.map((alt) => (
          <Button
            key={alt.id}
            size={SizeVariant.Small}
            onClick={handleRedirect(
              getLocaleFromAlternative(alt),
              alt.uid ?? (router?.query?.id as string) ?? ''
            )}
          >
            {`${getLocaleFromAlternative(alt)} - ${getTitle(
              getLocaleFromAlternative(alt)
            )}`}
          </Button>
        ))}
      </div>
    </div>
  )
}

export default AlternativeArticleLang
